import axios, { AxiosInstance } from 'axios'
import { message } from 'antd'
import { signOut } from '@/utils/utils'
import i18next from "i18next";
import { store } from './index'
import urljoin from 'url-join'
import { history } from "@/route";

export const picURL = "https://wpg.wapipay.com/remit-service/profile/" // 图片url

export const productionUrl = "https://global-api-new.wapipay.com/" // 线上环境
export const stagingUrl = "https://global-api-staging.beblur.com/" // 测试环境

export const productionWebUrl = "https://global.wapipay.com/" // 线上环境
export const stagingWebUrl = "https://global-staging.beblur.com/" // 测试环境


export const baseURL = process.env.REACT_APP__ENV === 'production' ? productionUrl : stagingUrl;

export const baseWebURL = process.env.REACT_APP__ENV === 'production' ? productionWebUrl : stagingWebUrl;

export const getToken = () => {
  const tokenItem = document.cookie.split(';').find(item => ~item.substring(0, 10).indexOf('token'))
  const token = tokenItem && tokenItem.slice(tokenItem.indexOf('=') + 1)
  if (token) {
    return token
  }
  return ''
}

let params = {
  baseURL,
  timeout: 100000,
  headers: {
  }
}

let instance: AxiosInstance = axios.create(params)

instance.interceptors.request.use(function (config) {
  const {
    // @ts-ignore
    tmpToken,
    url
  } = config
  const token = getToken()
  const { userInfo: { id } = {} } = store.getState().UserInfoReducer
  token && (config.headers['Authorization'] = `Bearer ${token}`)
  id && (config.headers['userId'] = `${id}`)
  config.headers.Version = '2.0.0'
  const lang = localStorage.getItem("wapipay-website-locale") || 'zh'
  config.url = urljoin(url || '', `?lang=${lang}`)
  if (tmpToken) {
    config.headers['tmp-token'] = tmpToken
  }
  return config;
}, function (error) {
  message.error(i18next.t("网络异常！"))
  return Promise.reject(error);
})


instance.interceptors.response.use(function (response) {
  const data = response?.data;
  // if (response.config.$sourceData) {
  //   return data
  // }
  // console.log('response=>', response)
  try {
    if (response.config.responseType === 'blob') {
      return data;
    }
    switch (data.code) {
      case 200:
        return data && data.data ? data.data : data;
      case 401:
        message.warning(i18next.t('会话超时！请再次登录以继续。'))
        signOut()
        setTimeout(() => {
          history.push('/home')
          window.location.reload()
        }, 2000);
        break;
      default:
        message.warning(data.msg)
        return Promise.reject(data);
    }
  } catch (error) {
    return Promise.reject(error);
  }
}, function (error) {
  const errorRes = error?.response
  const errorInfo = errorRes?.data
  try {
    // 登陆过期 //Login expired
    if (errorRes.status === 401) {
      message.warning(i18next.t('会话超时！请再次登录以继续。')) //Session timed out! Please log in again to continue.
      signOut()
      setTimeout(() => {
        history.push('/home')
        window.location.reload()
      }, 2000);
    }
    if (errorInfo.msg) {
      message.error(errorInfo.msg)
    } else {
      message.error(i18next.t('网络异常！请稍后重试！')) //Network abnormality! Please try again later!
    }
  } catch (error) {
    message.error(i18next.t('网络异常！请刷新后重试！')) //Network abnormality! Please refresh and try again!
  }
  return Promise.reject(errorInfo);
})

export default instance
